import packageJson from '../../package.json';

/**
 * Get the app version number but return a string if run by jest
 */
export function getPackageVersionNumber(): string {
  if (process.env.NODE_ENV !== 'production') {
    return 'x.x.x';
  } else {
    return packageJson.version;
  }
}
